const formatDateValue = (dateValue) => {
	if (!dateValue) return '-';
	try {
		const date = new Date(dateValue);
		if (isNaN(date.getTime())) return dateValue;
		return date.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
	} catch {
		return dateValue;
	}
};

const formatDateTimeValue = (dateValue) => {
	if (!dateValue) return '-';
	try {
		const date = new Date(dateValue);
		if (isNaN(date.getTime())) return dateValue;
		return date.toLocaleString('es-CL', { 
			day: '2-digit', 
			month: '2-digit', 
			year: 'numeric',
			hour: '2-digit',
			minute: '2-digit',
			hour12: false
		});
	} catch {
		return dateValue;
	}
};

export const adaptOrderInfo = (preorderData) => {
	if (!preorderData) return [];
console.log('Adapting order info with preorderData:', preorderData);
	const type_retirement = preorderData?.purchase_detail?.info?.type_retirement;
	const orderDate = preorderData?.payment_tracking?.[0]?.created_at || preorderData?.created_at;
	const estimatedDate = type_retirement === 'domicilio' 
		? preorderData?.purchase_detail?.info?.info_delivery?.date_schedule_narma 
		: null;

	return [{
		key: 'order-1',
		trx_id: preorderData?.trx_id || '-',
		tracking_id: preorderData?.tracking_id || '-',
		quotation_id: preorderData?.quotation?.quotation_id || '-',
		short_code: preorderData?.quotation?.short_code || '-',
		request_number: preorderData?.id || '-',
		order_date: formatDateTimeValue(orderDate),
		estimated_delivery_date: formatDateValue(estimatedDate),
	}];
};
